import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.167 5.533 10.5 3.867 5.333 6.7l4 4 2.834-5.167Z" fill="currentColor" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /> <path d="m12.167 5.533.666.667-.666-.667Z" fill="currentColor" /> <path d="m9.833 3.2.667.667 1.667 1.666.666.667M4.5 5.833l5.667 5.667M7.333 8.667l-4.166 4.166" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);